<template>
    <div>
        <Pane title="重新提交专业提资" :showRemarks="false">
            <template>重新发起专业提资流程</template>
        </Pane>

        <div class="container">
            <a-skeleton :loading="loading" :paragraph="{ rows: 12 }">
                <a-form :model="form" layout="horizontal" :colon="false" label-align="right"
                        :label-col="{ span: 8 }"
                        :wrapper-col="{ span: 12 }">
                    <div class="title" style="margin-top: 0">基本信息</div>
                    <div class="wrapper">
                        <a-row :gutter="16" class="form-panel">
                            <a-col :span="12">
                                <a-form-item label="工程名称">
                                    <a-input v-model="form.projectName" disabled />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="工程编号">
                                    <a-input v-model="form.projectCode" disabled />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="项目阶段">
                                    <a-select v-model="form.phaseCode" disabled placeholder="">
                                        <a-select-option v-for="item in designPhaseList" :key="item.value" :value="String(item.value)">{{ item.name }}</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="提资专业">
                                    <a-select v-model="form.fromMajorCode" disabled placeholder="">
                                        <a-select-option v-for="item in majorList" :key="item.value" :value="String(item.value)">{{ item.name }}</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="子项名称">
                                    <a-select mode="multiple" v-model="selectedSubItems" placeholder="请选择子项" style="width: 100%" @change="handleSubItemChange">
                                        <a-select-option v-for="item in subItemList" :key="item.subCode" :value="String(item.subCode)">{{ item.subName }}</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="提资专业负责人">
                                    <a-input v-model="form.fromLeaderNames" disabled />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="审核人名称">
                                    <a-select mode="multiple" v-model="selectedAuditors" placeholder="请选择审核人" style="width: 100%" @change="handleAuditorChange">
                                        <a-select-option v-for="item in auditorOptions" :key="item.id" :value="String(item.name)">{{ item.name }}</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="设计负责人" prop="designLeaderNames">
                                    <a-input v-model="form.designLeaderNames" placeholder="多个用逗号分隔" disabled/>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="接收专业">
                                    <a-select mode="multiple" v-model="selectedToMajors" placeholder="请选择接收专业" style="width: 100%" @change="handleToMajorChange">
                                        <a-select-option v-for="item in toMajorOptions" :key="item.key || item.value" :value="String(item.key || item.value)">{{ item.name }}</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="接收专业负责人">
                                    <a-input v-model="form.toLeaderNames" disabled />
                                </a-form-item>
                            </a-col>
                            <a-col :span="24">
                                <a-form-item label="设计条件" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                                    <a-textarea v-model="form.designCondition" :rows="3" style="max-width: 100%!important;width: 100%!important;" placeholder="请输入设计条件" />
                                </a-form-item>
                            </a-col>
                            <a-col :span="24">
                                <a-form-item label="备注" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                                    <a-textarea v-model="form.remark" :rows="3" style="max-width: 100%!important;width: 100%!important;" placeholder="请输入备注" />
                                </a-form-item>
                            </a-col>
                            <a-col :span="24">
                                <a-form-item label="附件" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                                    <Attachment :editable="true" :fileList="fileList" @change="fileList = $event" />
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </div>

                    <div class="center">
                        <a-space>
                            <a-button type="primary" @click="submitReview" :loading="submitting">
                                重新提交
                            </a-button>
                            <a-button @click="goBack">返回</a-button>
                        </a-space>
                    </div>
                </a-form>
            </a-skeleton>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import { getMajorTransferDetail as fetchDesignTransferDetail, resubmitMajorTransfer } from '@/api/project-design/transfer'
import { parseAttachment, buildAttachmentData } from '@/utils/attachment'
import Attachment from "@/components/attachment";

export default {
    name: "MajorTransferReapply",
    components: { Attachment },
    data() {
        return {
            loading: false,
            submitting: false,
            id: "",
            taskId: "",
            instanceId: "",
            form: {
                projectName: "",
                projectCode: "",
                phaseId: "",
                phaseCode: "",
                fromMajorCode: "",
                subCodes: "",
                subNames: "",
                fromLeaderNames: "",
                fromLeaderIds: "",
                designAuditorNames: "",
                designAuditorIds: "",
                toMajorCodes: "",
                toLeaderNames: "",
                toLeaderIds: "",
                designLeaderNames:"",
                designLeaderIds:"",
                designCondition: "",
                remark: "",
                attachment: "",
                attachmentPaths: "",
            },
            fileList: [],
            selectedSubItems: [],
            selectedToMajors: [],
            selectedAuditors: [],
            subItemList: [],
            auditorOptions: [],
        };
    },
    computed: {
        ...mapGetters("setting", ["findDataDict"]),
        majorList() {
            return (this.findDataDict && this.findDataDict("cosys.major")) || [];
        },
        designPhaseList() {
            return this.findDataDict('cosys.designPhase') || [];
        },
        toMajorOptions() {
            const majorDict = (this.findDataDict && this.findDataDict("cosys.major")) || [];
            const currentMajor = this.$store.getters['currentPlanProject/currentMajor'];
            const tabs = this.$store.getters['currentPlanProject/majorTabs'] || [];
            let options = [];
            if (tabs.length) {
                options = tabs.map(tab => {
                    const dictItem = majorDict.find(item => item.value === tab.key);
                    return { key: tab.key, name: dictItem ? dictItem.name : tab.name || tab.key };
                });
            } else {
                options = majorDict.map(item => ({ key: item.value, name: item.name }));
            }
            if (currentMajor) {
                options = options.filter(item => String(item.key) !== String(currentMajor));
            }
            return options;
        },
    },
    mounted() {
        const { taskId, instanceId } = this.$route.query;
        this.taskId = taskId || "";
        this.instanceId = instanceId || "";

        const routeId = this.$route.params.id;
        if (routeId) {
            this.id = routeId;
        } else {
            const { businessKey } = this.$route.query;
            if (businessKey) {
                const parts = businessKey.split(":");
                this.id = parts.length > 1 ? parts[1] : "";
            }
        }

        if (this.taskId && this.instanceId) {
            this.setTaskId(this.taskId);
            this.setInstanceId(this.instanceId);
        }

        this.fetchDetail();
    },
    methods: {
        ...mapMutations("approval", ["setTaskId", "setInstanceId"]),
        fetchDetail() {
            if (!this.id) {
                this.loading = false;
                return;
            }
            this.loading = true;
            fetchDesignTransferDetail(this.id)
                .then(data => {
                    if (!data) return;
                    this.form = {
                        projectName: data.projectName || "",
                        projectCode: data.projectCode || "",
                        phaseId: data.phaseId || "",
                        phaseCode: data.phaseCode ? String(data.phaseCode) : "",
                        fromMajorCode: data.fromMajorCode ? String(data.fromMajorCode) : "",
                        subCodes: data.subCodes || "",
                        subNames: data.subNames || "",
                        fromLeaderNames: data.fromLeaderNames || "",
                        fromLeaderIds: data.fromLeaderIds || "",
                        designAuditorNames: data.designAuditorNames || "",
                        designAuditorIds: data.designAuditorIds || "",
                        toMajorCodes: data.toMajorCodes || "",
                        designLeaderNames: data.designLeaderNames || "",
                        designLeaderIds: data.designLeaderIds || "",
                        toLeaderNames: data.toLeaderNames || "",
                        toLeaderIds: data.toLeaderIds || "",
                        designCondition: data.designCondition || "",
                        remark: data.remark || "",
                        attachment: data.attachment || "",
                        attachmentPaths: data.attachmentPaths || "",
                    };

                    this.selectedSubItems = (data.subCodes || '').split(',').filter(Boolean);
                    this.selectedToMajors = (data.toMajorCodes || '').split(',').filter(Boolean);
                    this.selectedAuditors = (data.designAuditorNames || '').split(',').filter(Boolean);

                    const subNamesArr = (data.subNames || '').split(',').filter(Boolean);
                    const subCodesArr = (data.subCodes || '').split(',').filter(Boolean);
                    this.subItemList = subCodesArr.map((code, i) => ({
                        subCode: code,
                        subName: subNamesArr[i] || code,
                    }));

                    const auditorNamesArr = (data.designAuditorNames || '').split(',').filter(Boolean);
                    const auditorIdsArr = (data.designAuditorIds || '').split(',').filter(Boolean);
                    this.auditorOptions = auditorNamesArr.map((name, i) => ({ name, id: auditorIdsArr[i] || '' }));

                    this.fileList = parseAttachment(data.attachment, data.attachmentPaths);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleSubItemChange(selectedCodes) {
            const selected = this.subItemList.filter(item => selectedCodes.includes(String(item.subCode)));
            this.form.subCodes = selected.map(item => item.subCode).filter(Boolean).join(',');
            this.form.subNames = selected.map(item => item.subName).filter(Boolean).join(',');
        },
        handleAuditorChange(selectedNames) {
            const ids = selectedNames.map(name => {
                const item = this.auditorOptions.find(o => o.name === name);
                return item ? item.id : '';
            }).filter(Boolean);
            this.form.designAuditorNames = selectedNames.join(',');
            this.form.designAuditorIds = ids.join(',');
        },
        handleToMajorChange(selectedKeys) {
            this.form.toMajorCodes = selectedKeys.join(',');
        },
        submitReview() {
            this.submitting = true;
            const { attachment, attachmentPaths } = buildAttachmentData(this.fileList);
            const data = {
                id: this.id,
                projectName: this.form.projectName,
                projectCode: this.form.projectCode,
                phaseId: this.form.phaseId,
                phaseCode: this.form.phaseCode,
                fromMajorCode: this.form.fromMajorCode,
                subCodes: this.form.subCodes,
                subNames: this.form.subNames,
                fromLeaderIds: this.form.fromLeaderIds,
                fromLeaderNames: this.form.fromLeaderNames,
                designAuditorIds: this.form.designAuditorIds,
                designAuditorNames: this.form.designAuditorNames,
                toMajorCodes: this.form.toMajorCodes,
                toLeaderIds: this.form.toLeaderIds,
                toLeaderNames: this.form.toLeaderNames,
                designLeaderNames: this.form.designLeaderNames,
                designLeaderIds: this.form.designLeaderIds,
                designCondition: this.form.designCondition,
                remark: this.form.remark,
                attachment,
                attachmentPaths,
            };
            resubmitMajorTransfer(data)
                .then(() => {
                    const extra = {
                        ...this.$store.state.approval.detail?.extra,
                        ...this.form,
                    };
                    delete extra.seqNum;
                    return this.finishTask({
                        notifyPeople: [],
                        map: { operation: "COMPLETED" },
                        extra: JSON.stringify(extra),
                    });
                })
                .then(() => {
                    this.$close(this.$route.path, "/project-service/approval/task");
                })
                .catch((e) => {
                    console.error("提交失败详情", e);
                    this.$message.error("提交失败");
                })
                .finally(() => {
                    this.submitting = false;
                });
        },
        goBack() {
            this.$close(this.$route.path);
        },
    },
};
</script>

<style lang="less" scoped>
.container {
    background-color: #fff;
    padding: 24px 160px;
}

.wrapper {
    background-color: #f9f9f9;
    padding-top: 24px;
    padding-bottom: 8px;
}

.title {
    font-weight: bold;
    font-size: 17px;
    margin: 12px 0;
}

.center {
    margin-top: 80px;
    display: flex;
    justify-content: center;
}
</style>
